import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CadastrarProdutoLayer from "../components/CadastrarProdutoLayer";
import { useTranslation } from "../i18n/I18nContext";

const CadastrarProdutoPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("produto.breadcrumb.create")} />
      <CadastrarProdutoLayer />
    </MasterLayout>
  );
};

export default CadastrarProdutoPage;
